import type { StepType } from "@reactour/tour";
import TourStepContent from "./wrapper";
import { switchToLevel } from "../ai-first/helpers";
import { text } from "@quickpoint.me/shared";

const keyboardNav: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => <strong>{text.tourSteps.a11yKeyboardNavHeading}</strong>}
			/>
		),
		position: "center",
	},
	{
		selector: "[role='tablist']",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.a11yAriaTabs}
						<br />
						<br />
						- {text.tourSteps.a11yArrowKeys}
						<br />
						- {text.tourSteps.a11yEnterSpace}
						<br />
						- {text.tourSteps.a11yAriaSelected}
					</span>
				)}
			/>
		),
		action: () => {
			switchToLevel(1);
		},
	},
	{
		selector: "[data-testid='bold-control']",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11yShortcutsHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11yShortcutsIntro}
						<br />
						<br />
						- {text.tourSteps.a11yBold}
						<br />
						- {text.tourSteps.a11yItalic}
						<br />
						- {text.tourSteps.a11yUnderline}
						<br />
						<br />
						{text.tourSteps.a11yNoClicking}
					</span>
				)}
			/>
		),
		action: () => {
			switchToLevel(3);
		},
	},
];

export default keyboardNav;
